import { NotebookPageContentBlock } from "constants/notebooks/notebook-page-content-blocks";
import { CodeReferenceBlockConfiguration } from "models/interfaces/block-configurations/code-reference-block-configuration";
import { ImageBlockConfiguration } from "models/interfaces/block-configurations/image-block-configuration";
import { TextBlockConfiguration } from "models/interfaces/block-configurations/text-block-configuration";
import { ChecklistBlockConfigurationRecord } from "models/view-models/block-configurations/checklist-block-configuration-record";
import { CodeReferenceBlockConfigurationRecord } from "models/view-models/block-configurations/code-reference-block-configuration-record";
import { ImageBlockConfigurationRecord } from "models/view-models/block-configurations/image-block-configuration-record";
import { TextBlockConfigurationRecord } from "models/view-models/block-configurations/text-block-configuration-record";
import { BlockRecord } from "models/view-models/block-record";
import StringUtils from "utilities/string-utils";

const usePopulatedBlocks = (blocks?: BlockRecord[]) => {
    const isPopulatedChecklist = (
        checklistBlock: ChecklistBlockConfigurationRecord
    ) =>
        checklistBlock?.items &&
        checklistBlock.items.some((item) => StringUtils.hasValue(item.text));

    // Kept to show that all text blocks are included, regardless of content or lack thereof
    const isPopulatedText = (_: TextBlockConfiguration) => true;

    const isPopulatedCodeReference = (
        codeReferenceBlock: CodeReferenceBlockConfiguration
    ) => !!codeReferenceBlock?.sectionId;

    const isPopulatedImage = (imageBlock: ImageBlockConfiguration) =>
        !!imageBlock?.imageFileId;

    const populatedBlocks =
        blocks?.filter((item) => {
            switch (item.type) {
                case NotebookPageContentBlock.Checklist:
                    return isPopulatedChecklist(
                        item.configuration as ChecklistBlockConfigurationRecord
                    );
                case NotebookPageContentBlock.Text:
                    return isPopulatedText(
                        item.configuration as TextBlockConfigurationRecord
                    );
                case NotebookPageContentBlock.CodeReference:
                    return isPopulatedCodeReference(
                        item.configuration as CodeReferenceBlockConfigurationRecord
                    );
                case NotebookPageContentBlock.Image:
                    return isPopulatedImage(
                        item.configuration as ImageBlockConfigurationRecord
                    );
                default:
                    return true;
            }
        }) ?? [];

    return {
        populatedBlocks,
    };
};

export default usePopulatedBlocks;
